import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PreviousButton from './PreviousButton';
import NextButton from './NextButton';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  previousButton: {
    marginRight: theme.spacing(1),
  },
  nextButton: {},
});

const OnboardingNavigator = ({
  className,
  classes,
  onNext,
  onPrevious,
  PreviousButtonProps,
  NextButtonProps,
  isLoading,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {onPrevious
        ? (
          <PreviousButton
            className={classes.previousButton}
            onClick={onPrevious}
            {...PreviousButtonProps}
          />
        ) : null}
      <NextButton
        className={classes.nextButton}
        onClick={onNext}
        isLoading={isLoading}
        buttonLabel={'Continue'}
        {...NextButtonProps}
      />
    </Box>
  );
};

OnboardingNavigator.defaultProps = {
  className: '',
  onPrevious: null,
  isLoading: false,
  NextButtonProps: {},
  PreviousButtonProps: {},
};

OnboardingNavigator.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrevious: PropTypes.func,
  isLoading: PropTypes.bool,
  PreviousButtonProps: PropTypes.object,
  NextButtonProps: PropTypes.object,
};

export default withStyles(styles)(OnboardingNavigator);
